import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import PhoneScreen from "@/pages/PhoneScreen";
import StudentScreen from "@/pages/StudentScreen";
import AdminScreen from "@/pages/AdminScreen";
import LoginScreen from "@/pages/LoginScreen";
import ExamScreen from "@/pages/ExamScreen";
import InstructorScreen from "@/pages/InstructorScreen";
import DocumentationScreen from "@/pages/DocumentationScreen";
import RecuperarContrasenaScreen from "@/pages/RecuperarContrasenaScreen";
import CambiarContrasenaScreen from "@/pages/CambiarContrasenaScreen";
import {
  ProtectedAdminRoute,
  ProtectedInstructorRoute,
} from "@/components/ProtectedAdminRoute";
import BackGuard from "@/components/BackGuard";
import ProposalScreen from "@/pages/ProposalScreen";

function App() {
  return (
    <div className="App min-h-screen bg-background text-foreground">
      <BrowserRouter>
        <BackGuard />
        <Routes>
          <Route path="/" element={<PhoneScreen />} />
          <Route path="/student" element={<StudentScreen />} />
          <Route path="/propuesta/:token" element={<ProposalScreen />} />
          <Route path="/exam" element={<ExamScreen />} />
          <Route
            path="/admin/login"
            element={
              <LoginScreen
                expectedRole="admin"
                badge="Acceso Gestor"
                title="Iniciar sesión"
                subtitle="Introduce tus credenciales para administrar cursos, asistencias y preguntas."
              />
            }
          />
          <Route
            path="/instructor/login"
            element={
              <LoginScreen
                expectedRole="instructor"
                badge="Acceso Instructor"
                title="Iniciar sesión"
                subtitle="Introduce el correo y la contraseña que te haya facilitado el gestor."
              />
            }
          />
          <Route
            path="/instructor/recuperar-contrasena"
            element={<RecuperarContrasenaScreen />}
          />
          <Route
            path="/instructor/cambiar-contrasena"
            element={
              <ProtectedInstructorRoute>
                <CambiarContrasenaScreen />
              </ProtectedInstructorRoute>
            }
          />
          <Route
            path="/admin/recuperar-contrasena"
            element={<RecuperarContrasenaScreen />}
          />
          <Route
            path="/admin/cambiar-contrasena"
            element={
              <ProtectedAdminRoute>
                <CambiarContrasenaScreen />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <ProtectedAdminRoute>
                <AdminScreen />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path="/admin/documentation"
            element={
              <ProtectedAdminRoute>
                <DocumentationScreen />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path="/instructor"
            element={
              <ProtectedInstructorRoute>
                <InstructorScreen />
              </ProtectedInstructorRoute>
            }
          />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors offset={80} />
    </div>
  );
}

export default App;
